import { useEffect } from "react";
import { useSessionContext } from "../SessionContext";

/**
 * Hook to refresh points balance on component mount.
 * Use this hook in pages/components where points should be refreshed.
 */
export const useRefreshPoints = () => {
  const { refreshPoints } = useSessionContext();

  useEffect(() => {
    refreshPoints();
  }, [refreshPoints]);
};
